import useCheckIfCurrentCompanyMatchesId, {
    UseCheckIfCurrentCompanyMatchesIdResult,
} from '../useCheckIfCurrentCompanyMatchesId';

/**
 * This hook checks if the current company is PECO.
 * It compares the current company ID (from settings) with the PECO company ID stored in the
 * PECO_SETTINGS constant (part of the Webpack build settings).
 */
const useCheckIfCurrentCompanyIsPECO = (): UseCheckIfCurrentCompanyMatchesIdResult =>
    useCheckIfCurrentCompanyMatchesId(PECO_SETTINGS.COMPANY_ID);

export default useCheckIfCurrentCompanyIsPECO;
